/* eslint-disable no-unused-vars */
import React from 'react';
import { TextField, Typography, FormControl, Grid, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ErrorIcon from '@mui/icons-material/Error';
import './styles.scss';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
    marginTop: theme?.spacing(1),
  },
  label: {
    lineHeight: '30px',
  },
  Input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme?.spacing(0),
    },
    '& .MuiInputBase-inputSizeSmall': {
      padding: theme?.spacing(1, 1.5),
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall': {
      borderColor: '#B72755',
    },
    '& .MuiFormHelperText-marginDense': {
      margin: theme?.spacing(0.5, 0.5, 0, 0.5),
    },
  },
}));

export default function Input(props) {
  const {
    name, value, label, required, placeholder, variant = 'outlined', error = null, size = 'small', fullWidth, type = '', warningIcon, maxLength, onChange, labelClass, className, fontSize, ...others
  } = props;
  const classes = useStyles();
  return (
    <FormControl variant={variant} className={classes?.formControl} {...(error && { error: 'true', helpertext: error })}>
      <Grid container spacing={0}>
        <Grid item xs={12} md={4} >
          <Typography
            component="p"
            fontSize={fontSize}
            className={`${required ? 'inputLabel required' : 'inputLabel'} ${classes?.label} ${labelClass}`}
          >{label} {warningIcon && <span className="warn-title" title={warningIcon}><ErrorIcon /></span>}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} className={className}>
          <TextField
            sx={{
              // height: '100px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '4px',
              },
            }}
            placeholder={placeholder}
            variant="outlined"
            name={name}
            onChange={onChange}
            type={type}
            size={size}
            fullWidth={fullWidth}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={
              {
                maxlength: maxLength,
              }
            }
            value={value}
            {...others}
            {...(error && { error: 'true', helpertext: error })}
            className={classes?.Input}
          />
          <FormHelperText>{error && error}</FormHelperText>
        </Grid>
      </Grid>
    </FormControl>
  );
}
